export default {
    url: '/detail/:id?section',
    template: `
        <user-employee-detail
            user="vm.user"
            direct-managers="vm.directManagers"
            departments="vm.departments"
            roles="vm.roles"
            levels="vm.levels"
            countries="vm.countries"
            site-id="vm.siteId"
        />`,
    resolve: {
        user (UserResource, $stateParams) {
            return UserResource.get({
                id: $stateParams.id,
                expand: [
                    'drlsWithValue,inactivityPeriods,directManagers,userDirectManagers,drls,employeeRoleSites',
                    'userAssignments,files.users,files.addedBy,files.occurrence,anonymizationDate'
                ].join(',')
            }).$promise;
        },
        directManagers (UserManagerService) {
            return UserManagerService.queryDirectManagersByPrivileges();
        }
    },
    controller (CLASSIFIER_ENUM, TokenService, user, directManagers, classifiers, countries) {
        this.siteId = TokenService.getActiveSiteId();
        this.user = user;
        this.directManagers = directManagers;
        this.departments = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.DEPARTMENT);
        this.roles = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.ROLE);
        this.levels = classifiers.filter((classifier) => classifier.type === CLASSIFIER_ENUM.KEYS.LEVEL);
        this.countries = countries;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/employee/detail/index.js